//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import { mapGetters, mapState } from "vuex";

export default {
    name: "QfMAppErrors",
    components: { AQModal },
    props: {
        fields: { type: Array, default: () => [] },
        isSmallScreen: { type: Boolean, default: false }
    },
    data() {
        return {
            localShow: true,
            activeIndexes: []
        };
    },
    computed: {
        ...mapState("components", ["properties"]),
        ...mapGetters("components", ["getErrorsClicked"]),
        fieldList() {
            const fields = [];

            this.fields.forEach((field, idx) => {
                let props;
                if (typeof field === "object" && !Array.isArray(field) && field !== null) {
                    props = field.code ? this.properties[field.code] : this.properties[field.key];
                } else {
                    props = this.properties[field];
                }

                fields.push({
                    fieldData: field.key ? field.localPath : field,
                    props,
                    guid: field.code || field.key ? field.code || field.key : field,
                    code: field.code || field.key ? (field.code || field.key) + idx : field,
                    label: props.label || this.$t("globalDataModel.error"),
                    msg: field.errorMsg || (field.errorMsg !== undefined && field.errorMsg === "") ? field.errorMsg : this.$t("userInterface.mandatoryField")
                });
            });

            return fields;
        }
    },
    created() {
        this.activeIndexes = this.getErrorsClicked;
    },
    methods: {
        modalAction(action) {
            if (action === "close") {
                this.localShow = false;
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        errorClicked(field) {
            const { code, guid, props, fieldData } = field;
            props.__generics.guid = guid;
            const errorObj = this.getComponentBacktraceObj(props, fieldData);
            if (!this.activeIndexes.includes(code)) {
                this.activeIndexes.push(code);
                this.$store.commit("components/setErrorsClicked", this.activeIndexes);
            }
            this.$emit("errorClicked", errorObj);
            this.localShow = false;
        },
        getComponentBacktraceObj(error, fieldPath, child, index) {
            if (typeof fieldPath === "object" && !Array.isArray(fieldPath) && fieldPath !== null) {
                if (fieldPath.parentCode && error.__generics.guid === fieldPath.parentCode.code) {
                    index = fieldPath.parentCode.index;
                    fieldPath = fieldPath.parentCode;
                } else if (!fieldPath.parentCode && error.__generics.guid === fieldPath.code) {
                    index = fieldPath.index;
                }
            }

            const obj = {
                componentId: error.__generics.idComp,
                componentCode: error.__generics.guid,
                componentType: error.__component,
                componentIndex: index,
                componentInitialPath: fieldPath.initialPath
            };
            if (child) {
                obj.child = child;
            }

            if (error.parent === false) {
                return {
                    error, fieldPath, obj, index
                };
            }

            const parentGuid = error.parent;
            error = this.properties[parentGuid];
            error.__generics.guid = parentGuid;

            return this.getComponentBacktraceObj(error, fieldPath, obj);
        }
    }
};
